import { Notice } from '@models/notices.types';

import { API_BASE_URL } from './api.constants';
import { generateApiUrl } from './api.utils';
import { authClient } from './client.api';

export const NOTICES_API_URLS = {
  NOTICES_FOR_REAL_ESTATE: `${API_BASE_URL}notices/:realEstateId`,
} as const;

/** Announcements, such as renovations and other real estate-wide announcements. */
export const noticesApi = {
  /** Fetches all announcements for the given real estate */
  fetchNoticesForRealEstate: (realEstateId: string) =>
    authClient.get<Notice[]>(
      generateApiUrl(NOTICES_API_URLS.NOTICES_FOR_REAL_ESTATE, { realEstateId })
    ),
};
